/* eslint-disable jsx-a11y/alt-text */

import React, { ChangeEvent, useState, useEffect, KeyboardEvent } from "react";
import {
  CharityPaymentLinkContainer,
  CharityPaymentLinkHeader,
  HeaderTitle,
  HorizontalLine,
  PaymentLinkTypeContainer,
  PaymentLinkTypeTitle,
  LinkTypeHolder,
  OptionsContainer,
  CheckBox,
  CheckboxLabel,
  RadioContainer,
  ButtonHolder,
  ButtonContainer,
  CharityInputContainer1,
  CreateInputField,
  CreateLabel,
  CharityInputContainer3,
  CreateLabel1,
  CreateInputField1,
  CharityInputContainer4,
  CreateLabel2,
  ShowAdvancedOpt,
  AdvancedOptionMain,
  CreateContentWrapper,
  CreateLinkSubHeader,
  CreateGoback,
  CreateLinkText,
  PreviewOfPaymentCreate,
  CreateLinkBigContainer,
  PaymentLinkCharityInput,
  PreviewAddNewGreen,
  PreviewAddNewGreenSpan,
  PaymentLinkWrap,
} from "./CreatePaymentLink.styles";
import PaymentLinkType from "../CharityDonation/PaymentLinkTypeHeader";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";
import AdvancedOptions from "./AdvancedOptions";
import CreatePaymentCard from "./CreatePaymentCard";
import {
  LouisannaBag,
  GoBackIcon,
  AddIcon,
  AddIconGreen,
} from "../../../public/assets";
import PreviewOfPayment from "../../components/PreviewOfPayment/PreviewOfPayment.component";
import SelectLabels from "./CreatePaymentSelect";
import CharityPaymentLink from "../CharityDonation/CharityPaymentLink";
import CharityPreviewOfPayment from "../CharityDonation/CharityPreview";
import { useNavigate } from "react-router-dom";
import {
  GET_ALL_PRODUCTS,
  GET_ALL_PRODUCTS_BY_ORGANIZATION_ID,
  SEARCH_PRODUCT,
} from "../../graphql/queries/paymentlink";
import { useQuery, useMutation } from "@apollo/client";
import SelectPop, {
  ProductDropdownListItems,
} from "../CharityDonation/CharityPaymentLink/SelectPop";
import Successful from "../../components/SuccessfulCreationOfPaymentLink/index";

import { CreatePaymentLink } from "../../graphql/mutations/paymentlink";
import { getData } from "../../utils/localStorage";
import { environment } from "../../env";
import { useDispatch, useSelector } from "react-redux";
import {
  addSelectedProduct,
  clearSearchedProducts,
  resetSelectedProduct,
} from "../../store/products/productSlice";
import { debounce } from "../../utils/debounce";
import { ToastContainer, toast } from "react-toastify";
import AdhocPaymentLink from "../Adhoc";
import AdhocPreviewOfPayment from "../Adhoc/AdhocPreviewOfPayment";
import { saveCreatePaymentLink } from "../../store/products/createpaymentslice";
import { styled } from "styled-components";
import { LoadingSpinner } from "../AddUserPage/AddUser";
import CharityPaymentCard from "../CharityDonation/CharityPaymentLink/CharityPaymentCard";
import { setSearchedProducts } from "../../store/products/productSlice";

interface Product {
  id: string;
  image: string;
  name: string;
  price: number;
  quantity: number;
  from: number;
  to: number;
}

const type = getData("type");

const CreatePaymentLinks: any = () => {
  const dispatch = useDispatch();
  const { loading, error, data } = useQuery(
    GET_ALL_PRODUCTS_BY_ORGANIZATION_ID,
    {
      variables: {
        ...environment.paymentLinkService,
        payload: {
          limit: 10,
          page: 1,
        },
      },
    }
  );
  const [createPaymentLink] = useMutation(CreatePaymentLink, {
    variables: { ...environment.paymentLinkService },
  });
  const [values, setValues] = useState<string>("adhoc");

  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProductIds, setSelectedProductIds] = useState<
    { id: string }[]
  >([]);
  const {
    loading: loadingSearchProduct,
    error: errorSearchProduct,
    data: searchProductData,
  } = useQuery(SEARCH_PRODUCT, {
    variables: {
      ...environment.paymentLinkService,
      query: searchQuery,
      type:
        values === "products"
          ? "productsAndSubscription"
          : "charityAndDonation",
    },
  });
  const [products, setProducts] = useState<Product[]>([]);
  const [showSelectPop, setShowSelectPop] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [autoCompleteValue, setAutoCompleteValue] = useState("");
  const [checkedValue, setCheckedValue] = useState<string[]>([]);
  const [isChecked, setIsChecked] = useState(false);
  const [minimumPayment, setMinimumPayment] = useState<number>(0);
  const [taxCategory, setTaxCategory] = useState<string>("");
  const [includeTaxInPrice, setIncludeTaxInPrice] = useState<string>("");
  const [showAddress, setShowAddress] = useState("");
  const [showCharity, setShowCharity] = useState("");
  const [showTaxInfo, setShowTaxInfo] = useState("");
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [showPaymentInput, setShowPaymentInput] = useState(true);
  const [showPreviewAddNewGreen, setShowPreviewAddNewGreen] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [LinkOptions, setLinkOptions] = useState([
    {
      label: "Collect customer's address",
      value: "collectCustomersShippingAddress",
      isTrue: false,
    },
    {
      label: "Limit number of payments",
      value: "limitTheNumberOfPayments",
      isTrue: false,
    },
    {
      label: "Allow business customers to provide tax IDs",
      value: "allowBusinessCustomersToProvideTaxIds",
      isTrue: false,
    },
    {
      label: "Collect tax automatically",
      value: "collectTaxAutomatically",
      isTrue: false,
    },
  ]);
  const [formData, setFormData] = useState({
    redirectAfterPayment: "",
    successMessage: "",
    useYourCustomLink: "",
    url: "",
  });

  const selectedProducts: any = useSelector(
    (state: any) => state.products.selectedProduct
  );

  useEffect(() => {
    setValues("adhoc");
    dispatch(resetSelectedProduct());
  }, []);

  useEffect(() => {
    if (searchProductData) {
      const products = searchProductData.searchProduct;
      dispatch(setSearchedProducts(products));
    }
  }, [searchProductData, dispatch]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name) {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    if (!loading && data) {
      const { getAllProductsByOrganizationId } = data;
      if (getAllProductsByOrganizationId) {
        setProducts(getAllProductsByOrganizationId.data);
      }
    }
  }, [loading, data, searchProductData]);

  const NavigateBackPaymentLink = () => {
    navigate("/dashboard/payment-link");
  };

  const handleAddNewProductClick = () => {
    setShowPaymentInput(true);
    setShowSelectPop(false);
    setShowPreviewAddNewGreen(false);
  };

  const handleToggleAdvanceOptions = () => {
    setShowAdvancedOptions(!showAdvancedOptions);
  };

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchQuery(value);
  };

  const handleSetValue = (isActive: string) => {
    setValues(isActive);
    dispatch(resetSelectedProduct());
  };

  const handleCreatePaymentLink = async (event: any) => {
    event.preventDefault();
    try {
      const options: any = {};
      LinkOptions.forEach((option) => {
        if (option.isTrue) {
          options[option.value] = true;
        } else {
          options[option.value] = false;
        }
      });

      const products = selectedProducts
        ?.filter(
          ({ type }: any) => (types?.[values] || types.products) === type
        )
        ?.map(({ id }: any) => ({ id }));
      const response = await createPaymentLink({
        variables: {
          input: {
            type: types?.[values] || "productsAndSubscription",
            // organizationId: selectors,
            products,
            options: options,
            advanceOption: {
              redirectAfterPayment: formData.redirectAfterPayment,
              successMessage: formData.successMessage,
              useYourCustomLink: formData.useYourCustomLink,
            },
          },
        },
      });
      dispatch(saveCreatePaymentLink(response.data.createPaymentLink));
      const id = response.data?.createPaymentLink?.id;

      if (id) {
        navigate("/dashboard/success/" + id);
        toast.success("Payment link has been created successfully!");
      }
    } catch (error) {}
  };

  const handleCharityCard = () => {
    setShowSelectPop(!showSelectPop);
  };

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;

    const updatedOptions = LinkOptions.map((option) => {
      if (option.value === value) {
        return { ...option, isTrue: checked };
      }
      return option;
    });

    setCheckedValue((prevCheckedValue) => {
      const updatedCheckedValue = checked
        ? [...prevCheckedValue, value]
        : prevCheckedValue.filter((val) => val !== value);
      return updatedCheckedValue;
    });

    if (checked) {
      setCheckedValue([...checkedValue, value]);
      if (value === "collectCustomersShippingAddress") {
        setShowAddress(value);
      }
    } else {
      setCheckedValue(checkedValue.filter((val) => val !== value));
      if (value === "collectCustomersShippingAddress") {
        setShowAddress("");
      }
    }

    setLinkOptions(updatedOptions);
  };

  const handleCheckTax = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;

    if (checked) {
      setCheckedValue([...checkedValue, value]);
      if (value === "collectTaxAutomatically") {
        setShowTaxInfo(value);
      }
    } else {
      setCheckedValue(checkedValue.filter((val) => val !== value));
      if (value === "collectTaxAutomatically") {
        setShowTaxInfo("");
      }
    }
  };

  const handleMinimumPaymentChange = (e: ChangeEvent<HTMLInputElement>) => {
    let newValue = parseFloat(e.target.value);
    newValue = Math.min(Math.max(newValue, 1), 100);
    setMinimumPayment(newValue);
  };

  const handleIncludeTaxInPriceChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    setIncludeTaxInPrice(newValue);
  };

  const handleSelectedProduct = (product: any) => {
    dispatch(addSelectedProduct(product));
  };

  const types: any = {
    products: "productsAndSubscription",
    charity: "charityAndDonation",
    adhoc: "adhocPayment",
  };

  const handleProductTypeOnlyFilter = ({ id, type }: any) =>
    !(selectedProducts as any[])?.some?.(({ id: sId }) => sId === id) &&
    types?.[values] === type;

  const productSearchedItems =
    searchProductData?.searchProduct?.filter(handleProductTypeOnlyFilter) || [];

  return (
    <CreateLinkBigContainer>
      <CreateContentWrapper>
        <CreateLinkSubHeader>
          <img
            src="/assets/svg/goBack.svg"
            alt=""
            onClick={NavigateBackPaymentLink}
          />
          <CreateGoback>Go back</CreateGoback>
        </CreateLinkSubHeader>
        <CreateLinkText>Create Payment Link</CreateLinkText>
      </CreateContentWrapper>
      <PaymentLinkWrap>
        <CharityPaymentLinkContainer $noSelection={!values}>
          <CharityPaymentLinkHeader>
            <HeaderTitle>Create Payment Link</HeaderTitle>
          </CharityPaymentLinkHeader>
          <HorizontalLine />
          <PaymentLinkTypeContainer>
            {/* <PaymentLinkTypeTitle>Type of Payment Link</PaymentLinkTypeTitle> */}
            <LinkTypeHolder>
              <PaymentLinkType
                selected={values}
                onTypeChange={handleSetValue}
              />
            </LinkTypeHolder>
          </PaymentLinkTypeContainer>
          {values !== "adhoc" && (
            <div style={{ background: "white" }}>
              <div>
                <PaymentLinkTypeTitle>Product</PaymentLinkTypeTitle>
              </div>
              {loading && <div>Loading products...</div>}
              <div
                style={{
                  marginBottom: "20px",
                }}
              >
                {!loading &&
                  selectedProducts?.length > 0 &&
                  (selectedProducts || [])?.map((cardData: any) => (
                    <div key={cardData.id + cardData?.type}>
                      {values === "products" ? (
                        <CreatePaymentCard data={cardData} />
                      ) : (
                        <CharityPaymentCard data={cardData} />
                      )}
                    </div>
                  ))}
              </div>
              <PreviewAddNewGreen
                id="PreviewAddNewGreen"
                onClick={handleAddNewProductClick}
              >
                <img
                  src="/assets/svg/AddIconGreen.svg"
                  style={{
                    width: "13px",
                    height: "auto",
                    paddingRight: "10px",
                  }}
                />
                <PreviewAddNewGreenSpan>
                  Add product to List
                </PreviewAddNewGreenSpan>
              </PreviewAddNewGreen>

              {!showPreviewAddNewGreen && values !== "adhoc" && (
                <div id="not-showPreviewAddNewGreen">
                  {showSelectPop === false ? (
                    <PaymentLinkCharityInput
                      type="text"
                      placeholder="Search or add a product"
                      onFocus={() => setInputFocused(true)}
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                    />
                  ) : null}

                  {!loadingSearchProduct &&
                    productSearchedItems?.map((products: any) => (
                      <ProductDropdownListItems
                        key={products?.id}
                        img={products?.images?.[0]}
                        onClick={() => handleSelectedProduct(products)}
                        text={products?.name}
                      />
                    ))}

                  {!loadingSearchProduct && inputFocused && (
                    <SelectPop
                      id="SelectPop"
                      onClick={handleCharityCard}
                      pageType={(values || "products") as any}
                      loading={loadingSearchProduct || loading}
                    />
                  )}

                  {(loadingSearchProduct || loading) && (
                    <LoadingSpinner small />
                  )}
                </div>
              )}
              <div>
                <OptionsContainer>
                  <PaymentLinkTypeTitle>Options</PaymentLinkTypeTitle>
                  <>
                    {LinkOptions.map((linkOption, index) => (
                      <div key={index}>
                        <RadioContainer>
                          <CheckBox
                            type="checkbox"
                            id={linkOption.value}
                            name={linkOption.value}
                            value={linkOption.value}
                            onChange={(event) => {
                              handleCheck(event);
                              handleCheckTax(event);
                            }}
                          />
                          <CheckboxLabel htmlFor={linkOption.value}>
                            {linkOption.label}
                          </CheckboxLabel>
                        </RadioContainer>
                        {/* Input fields for additional options */}
                        {linkOption.value === "limitTheNumberOfPayments" &&
                          checkedValue.includes("limitTheNumberOfPayments") && (
                            <CharityInputContainer1>
                              <CreateLabel>Minimum Payment</CreateLabel>
                              <CreateInputField
                                type="number"
                                value={minimumPayment}
                                onChange={handleMinimumPaymentChange}
                              />
                            </CharityInputContainer1>
                          )}
                        {linkOption.value === "collectTaxAutomatically" &&
                          checkedValue.includes("collectTaxAutomatically") && (
                            <CharityInputContainer3>
                              <CharityInputContainer4>
                                <CreateLabel1>Tax Category</CreateLabel1>
                                <SelectLabels />
                              </CharityInputContainer4>
                              <CharityInputContainer4>
                                <CreateLabel2>
                                  Include Tax in Price
                                </CreateLabel2>
                                <CreateInputField1
                                  value={includeTaxInPrice}
                                  onChange={handleIncludeTaxInPriceChange}
                                >
                                  <option value="yes">Yes</option>
                                  <option value="no">No</option>
                                </CreateInputField1>
                              </CharityInputContainer4>
                            </CharityInputContainer3>
                          )}
                      </div>
                    ))}
                  </>
                </OptionsContainer>
              </div>
              <AdvancedOptionMain onClick={handleToggleAdvanceOptions}>
                {showAdvancedOptions ? (
                  <ShowAdvancedOpt>Hide advanced options</ShowAdvancedOpt>
                ) : (
                  <ShowAdvancedOpt>Show advanced options</ShowAdvancedOpt>
                )}
                {showAdvancedOptions && (
                  <AdvancedOptions
                    handleChange={handleChange}
                    formData={formData}
                  />
                )}
              </AdvancedOptionMain>
              <HorizontalLine />
              <ButtonContainer>
                <ButtonHolder>
                  <Buttons
                    label="Create Payment Link"
                    color={
                      colors.ButtonBackgroundColors.primaryMediumHoverButton
                    }
                    borderRadius="10px"
                    cursor="pointer"
                    height="44px"
                    width="184px"
                    handleClick={handleCreatePaymentLink}
                    disabled={!!values && !selectedProducts.length}
                  />
                </ButtonHolder>
              </ButtonContainer>
            </div>
          )}
          {values === "adhoc" && (
            <>
              <div>
                <OptionsContainer>
                  <PaymentLinkTypeTitle>Options</PaymentLinkTypeTitle>
                  <>
                    {LinkOptions.map((linkOption, index) => (
                      <div key={index}>
                        <RadioContainer>
                          <CheckBox
                            type="checkbox"
                            id={linkOption.value}
                            name={linkOption.value}
                            value={linkOption.value}
                            onChange={(event) => {
                              handleCheck(event);
                              handleCheckTax(event);
                            }}
                          />
                          <CheckboxLabel htmlFor={linkOption.value}>
                            {linkOption.label}
                          </CheckboxLabel>
                        </RadioContainer>
                        {/* Input fields for additional options */}
                        {linkOption.value === "limitTheNumberOfPayments" &&
                          checkedValue.includes("limitTheNumberOfPayments") && (
                            <CharityInputContainer1>
                              <CreateLabel>Minimum Payment</CreateLabel>
                              <CreateInputField
                                type="number"
                                value={minimumPayment}
                                onChange={handleMinimumPaymentChange}
                              />
                            </CharityInputContainer1>
                          )}
                        {linkOption.value === "collectTaxAutomatically" &&
                          checkedValue.includes("collectTaxAutomatically") && (
                            <CharityInputContainer3>
                              <CharityInputContainer4>
                                <CreateLabel1>Tax Category</CreateLabel1>
                                <SelectLabels />
                              </CharityInputContainer4>
                              <CharityInputContainer4>
                                <CreateLabel2>
                                  Include Tax in Price
                                </CreateLabel2>
                                <CreateInputField1
                                  value={includeTaxInPrice}
                                  onChange={handleIncludeTaxInPriceChange}
                                >
                                  <option value="yes">Yes</option>
                                  <option value="no">No</option>
                                </CreateInputField1>
                              </CharityInputContainer4>
                            </CharityInputContainer3>
                          )}
                      </div>
                    ))}
                  </>
                </OptionsContainer>
                <AdvancedOptionMain onClick={handleToggleAdvanceOptions}>
                  {showAdvancedOptions ? (
                    <ShowAdvancedOpt>Hide advanced options</ShowAdvancedOpt>
                  ) : (
                    <ShowAdvancedOpt>Show advanced options</ShowAdvancedOpt>
                  )}
                  {showAdvancedOptions && (
                    <AdvancedOptions
                      handleChange={handleChange}
                      formData={formData}
                    />
                  )}
                </AdvancedOptionMain>
                {/* <ButtonContainer>
                  <ButtonHolder>
                    <Buttons
                      label="Create Payment Link"
                      color={
                        colors.ButtonBackgroundColors.primaryMediumHoverButton
                      }
                      borderRadius="10px"
                      cursor="pointer"
                      height="44px"
                      width="184px"
                      handleClick={handleCreatePaymentLink}
                      disabled={!!values && !selectedProducts.length}
                    />
                  </ButtonHolder>
                </ButtonContainer> */}
                <AdhocPaymentLink
                  formData={formData}
                  options={checkedValue}
                  LinkOptions={LinkOptions}
                />
              </div>
            </>
          )}
        </CharityPaymentLinkContainer>
        {values === "products" && (
          <PreviewOfPaymentCreate>
            <PreviewOfPayment
              showAddress={showAddress}
              showTaxInfo={showTaxInfo}
              searchProductData={selectedProducts}
            />
          </PreviewOfPaymentCreate>
        )}
        {values === "charity" && (
          <PreviewOfPaymentCreate>
            <CharityPreviewOfPayment showCharity={showCharity} />
          </PreviewOfPaymentCreate>
        )}
        {/* {values === "adhoc" && <AdhocPaymentLink />} */}
        {values === "adhoc" && (
          <PreviewOfPaymentCreate>
            <AdhocPreviewOfPayment showCharity={showCharity} />
          </PreviewOfPaymentCreate>
        )}
      </PaymentLinkWrap>
    </CreateLinkBigContainer>
  );
};

export default CreatePaymentLinks;
